module.exports = __webpack_public_path__ + "img/throwing_snowballs.98aced19.jpg";